import React from 'react'
import ResultPageERP from './ResultPageERP';

const ResultPage = ({data,setIsFinished}) => {
  
    const {selectedProductId, employeeCount, b2bWebshopEnabled, selectedProfile,invoiceProfileData} = data;
  
        if(selectedProductId == 13){
            return (<ResultPageERP data={data} setIsFinished={setIsFinished}/>)
        }


}

export default ResultPage